<template>
    <div class="related-docs-item">        
        <div class="name">{{ name }}</div>        
        <a @click="GTMProdCatClick" :href=" path_url + '/' + slug + file_name"  class="btn btn--green-border" target="_blank">
            {{ lang('Letoltes') }}  
        </a>     
    </div>
</template>

<script>

export default {
    props: ['name', 'slug', 'file_name'],
    data(){
        return{
            path_url: process.env.VUE_APP_BIFROST_API_URL_NO_PROJECTNAME
        }
    },
    methods:{
        GTMProdCatClick(){          
            this.setDataLayer('pdf_download', this.file_name, '')                  
        } 
    }  
}
</script>